var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.active)?_c('b-container',{attrs:{"id":"alert","fluid":""}},[_c('iq-card',{class:'alert alert-' + _vm.alert.type,attrs:{"role":"alert"}},[_c('div',{staticClass:"iq-alert-icon"},[_c('i',{staticClass:"ri-information-line"})]),_c('div',{staticClass:"iq-alert-text"},[_vm._v(_vm._s(_vm.alert.text))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }